export { roundToHundredths, USGSMeasureNormalizer } from '../../DeviceGraph/utils/measurementUtils';

/**
 * Builds a Map from `did` string to its index in `device.data`.
 *
 * @param {object} device - Device Object to build map for.
 * @returns {Map<string, number>} Map where keys are `did` (as string) and values are the
 *   zero-based index of that data point within `device.data`.
 */
export function buildDidToPageFromDevice(device) {
  const map = new Map();
  if (!device || !Array.isArray(device.data)) return map;
  device.data.forEach((dataPoint, index) => {
    if (dataPoint && dataPoint.did != null) map.set(String(dataPoint.did), index);
  });
  return map;
}

/**
 * Return a jsx result for known qualifier codes.
 *
 * @param {string[]} qualifierArray - Array of qualifier code strings.
 * @returns {JSX.Element|undefined} Renderer output or undefined when no match.
 *
 * Note: This function should be updated as more qualifier codes are identified and need special handling in the UI.
 */
export function qualifierHandler(qualifierArray) {
  const qualifierRenderers = {
    UNAVAIL: () => <strong>Data Unavailable</strong>,
    DISCONTINUED: () => <strong>Data Unavailable</strong>,
    // add more flags here: 'FLAG_CODE': () => <strong>Something</strong>
  };

  if (!Array.isArray(qualifierArray) || qualifierArray.length === 0) return undefined;
  for (const flag of qualifierArray) {
    // fast map lookup
    const renderer = qualifierRenderers[flag];
    if (typeof renderer === 'function') return renderer(flag);
  }
  return false; // no matching flags found
}
